<template>
  <nav class="menu-container">

    <RouterLink
      :exact="item.exact"
      v-for="item in items"
      :key="item.link"
      :to="{ name: item.name }"
      active-class="selected"
      exact-active-class=""
    >
      <div class="icon">
        <Icon :type="item.icon" />
      </div>
      <span>{{ item.title }}</span>
    </RouterLink>
    桃园站<br>
站点介绍<br>
桃园站位于南山区南山大道与桃园路交叉路口，呈东西走向布置。在站址周围有新桃园大厦、南山老干部活动中心等。车站装修以红色为主，粉红色为辅，给人一种世外桃源的感觉。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:00	23:28	1号线	2分钟	4分40秒<br>
机场东	06:06	23:40	1号线	2分钟	4分40秒<br>
左炮台东	06:21	23:17	12号线	4分钟	8分钟<br>
海上田园东	06:30	00:26	12号线	4分钟	8分钟<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:19	23:27	1号线	3分45秒	5分45秒<br>
机场东	06:30	23:39	1号线	3分45秒	5分45秒<br>
左炮台东	06:25	23:17	12号线	8分钟	8分钟<br>
海上田园东	06:32	23:55	12号线	8分钟	8分钟<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
罗湖	06:19	00:27	1号线	3分45秒	5分45秒<br>
机场东	06:30	00:39	1号线	3分45秒	5分45秒<br>
左炮台东	－	－	12号线	－	－<br>
海上田园东	－	－	12号线	－	－<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
桃园路北侧（东）、南光路、南海大道、深圳市南山区人民政府、深圳市南山区人民检察院、深圳大学、深圳市南山实验学校、荔香公园<br><br>
B出入口:<br>
桃园路北侧（西）、南山区图书馆、南山博物馆、南山文体中心、七巧国儿童中心<br><br>
C出入口:<br>
桃园路南侧、华中科技大学协和深圳医院（南山医院）D出入口<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 南山区委<br>
223、226、36、74、M453、M475、M242<br><br>
B出入口:<br>
公交站名： 市六医院<br>
122、204、223、226、331、332、36、58、M343、M453、M492、N4、M206、M242、M182、M349、M562、M176<br><br>
C出入口:<br>
公交站名： 市六医院<br>
122、204、223、226、332、36、58、M453、M492、N4、M206、M242、M343、M182、M562、M349、M176<br><br>
D出入口:<br>
公交站名： 市六医院东<br>
204、331、337、369、58、74、79、M371、M463、N4、M206、M241、332、M372、M182、M562、E3<br>
</nav>
</template>
<script>
// import Icon from "@/components/Icon";
export default {
  components: {
    // Icon,
  },
  data() {
    return {
      items: [
        {
          name: "yihaoxian",
          title: "1号线",
          // icon: "chat",
          exact: true,
        },
        {
          name: "shierhaoxian",
          title: "12号线",
          // icon: "chat",
          exact: true,
        },
      ],
    };
  },
};
</script>

<style scoped lang="less">
@import "~@/styles/var.less";
.menu-container {
  color: @words;
  margin: 24px 0;
  a {
    &.selected {
      background: darken(@words, 3%);
    }
    padding: 0 50px;
    display: block;
    display: flex;
    align-items: center;
    height: 45px;
    // .icon {
    //   width: 24px;
    // }
    &:hover {
      color: rgb(50, 95, 227);
    }
  }
}
</style>

